import React, { useState } from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";

const { Content } = Layout;

interface AppLayoutProps {
  isDark: boolean;
  onToggleTheme: () => void;
}

/**
 * Root application layout: collapsible sidebar + sticky header + scrollable content area.
 * Renders nested routes via React Router's <Outlet />.
 */
export function AppLayout({ isDark, onToggleTheme }: AppLayoutProps): React.JSX.Element {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />

      <Layout>
        <Header isDark={isDark} onToggleTheme={onToggleTheme} />

        <Content
          style={{
            padding: 24,
            overflow: "initial",
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
